import React from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { 
  RectangleStackIcon,
  ListBulletIcon,
  PaperClipIcon,
  CalendarIcon,
  ClockIcon,
  DocumentTextIcon,
  ChartBarIcon,
  CogIcon,
  ArchiveBoxArrowDownIcon,
  TrashIcon,
  DocumentMagnifyingGlassIcon,
  ClipboardDocumentListIcon
} from '@heroicons/react/24/outline'

const ProjectTabs: React.FC = () => {
  const { projectKey } = useParams<{ projectKey: string }>()

  const tabs = [
    { 
      name: '看板', 
      href: `/project/${projectKey}/board`, 
      icon: RectangleStackIcon,
      active: true
    },
    { 
      name: '列表', 
      href: `/project/${projectKey}/list`, 
      icon: ListBulletIcon,
      disabled: true
    },
    { 
      name: '行事曆', 
      href: `/project/${projectKey}/calendar`, 
      icon: CalendarIcon,
      disabled: true
    },
    { 
      name: '時間軸', 
      href: `/project/${projectKey}/timeline`, 
      icon: ClockIcon
    },
    { 
      name: '附件', 
      href: `/project/${projectKey}/attachments`, 
      icon: PaperClipIcon
    },
    { 
      name: '表單', 
      href: `/project/${projectKey}/forms`, 
      icon: DocumentTextIcon
    },
    { 
      name: '報表', 
      href: `/project/${projectKey}/reports`, 
      icon: ChartBarIcon,
      disabled: true
    },
    { 
      name: '工作日誌', 
      href: `/project/${projectKey}/worklogs`, 
      icon: ClipboardDocumentListIcon
    },
    { 
      name: '封存區', 
      href: `/project/${projectKey}/archived`, 
      icon: ArchiveBoxArrowDownIcon
    },
    { 
      name: '回收桶', 
      href: `/project/${projectKey}/trash`, 
      icon: TrashIcon
    },
    { 
      name: '專案日誌', 
      href: `/search?project=${projectKey}&types=activities`, 
      icon: DocumentMagnifyingGlassIcon
    },
    { 
      name: '設定', 
      href: `/project/${projectKey}/settings`, 
      icon: CogIcon
    }
  ]

  return (
    <div className="border-b border-gray-200 bg-white">
      <nav className="flex space-x-4 px-6 overflow-x-auto" aria-label="專案分頁">
        {tabs.map((tab) => {
          const Icon = tab.icon
          
          if (tab.disabled) {
            return (
              <div
                key={tab.name}
                className="flex items-center py-3 px-1 border-b-2 border-transparent text-gray-400 cursor-not-allowed whitespace-nowrap"
              >
                <Icon className="w-4 h-4 mr-1.5" />
                <span className="text-xs font-medium">{tab.name}</span>
              </div>
            )
          }

          return (
            <NavLink
              key={tab.name}
              to={tab.href}
              className={({ isActive }) =>
                `flex items-center py-3 px-1 border-b-2 text-xs font-medium transition-colors duration-200 whitespace-nowrap ${
                  isActive
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`
              }
            >
              <Icon className="w-4 h-4 mr-1.5" />
              {tab.name}
            </NavLink>
          )
        })}
      </nav>
    </div>
  )
}

export default ProjectTabs
